export const COMMISSION_TYPE_SALE = 'Sale';
export const COMMISSION_TYPE_LISTING = 'Listing';

export const CALCULATION_TYPE_FLAT = 'Flat';
export const CALCULATION_TYPE_PERCENT = 'Percent';

export const DEFAULT_COMMISSION_AMOUNT = 0;
